var map = {
	"./direpay.svg": 2316,
	"./doitnow.svg": 2317,
	"./duitnow.svg": 2318,
	"./fpay.svg": 2319,
	"./fpay2.svg": 2320,
	"./fpx.svg": 2321,
	"./online_banking.svg": 2322,
	"./secret_pay.svg": 2323,
	"./secret_pay_offline.svg": 2324,
	"./secret_pay_pro.svg": 2325,
	"./secret_pay_pro_b.svg": 2326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;